module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "CatalogItem"
  }, [_c('img', {
    staticClass: "CatalogItem__image",
    attrs: {
      "src": _vm.item.image
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "CatalogItem__header"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    staticClass: "CatalogItem__description"
  }, [_vm._v(_vm._s(_vm.item.description))]), _vm._v(" "), _c('div', {
    staticClass: "CatalogItem__bottom"
  }, [(_vm.item.isGroup) ? _c('BaseButtonFlat', {
    attrs: {
      "label": 'CATALOG__OPEN'
    },
    on: {
      "click": function($event) {
        _vm.openGroup(_vm.item)
      }
    }
  }) : _vm._e()], 1)])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40da1595"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/catalog/CatalogItem.vue
// module id = 594
// module chunks = 1